<template>
  <div>
    <div class="passport">
      <div class="row">
        <div class="col-md-3 col-sm-3 col-xs-3">
          <span class="name-label">Дата рождения</span>
          <p>{{ passport.birthday || '-' }}</p>
        </div>
        <div class="col-md-6 col-xs-6">
          <span class="name-label">Место рождения</span>
          <p>{{ passport.placebirth || '-' }}</p>
        </div>
        <div class="col-md-2 col-xs-2">
          <span class="name-label">Гражданство</span>
          <p v-if="passport.nationality && passport.nationality.iso2" class="visitor-nationality">
            <img
              :src="baseUrl + '/img/icons/' + passport.nationality.iso2 + '.svg'"
              alt="icon-flag"
              class='icon-flag'
            >{{ passport.nationality.fullName || '-' }}
          </p>
          <p v-else>-</p>
        </div>
        <div>
          <button
            :title="titleApplicationsButton"
            role="button"
            class="btn btn-default"
            @click="changeVisibleApplications"
          >
            <i class="fa fa-bars"></i>
            &nbsp;
            <i :class="{ 'fa-angle-down': !visibleApplications, 'fa-angle-up': visibleApplications }" class="fa"></i>
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3 col-xs-3 mobile-width-75" style="height: 65px">
          <span class="name-label">Вид документа</span>
          <p>{{ identification ? identification.name || '-' : '-' }}</p>
        </div>
        <div class="col-md-3 col-xs-3" style="height: 65px">
          <span class="name-label">Серия и номер</span>
          <span v-if="passportIsDuplicate()" class="visitor-passport-is-duplicate">
          <label style="margin-bottom: auto">!</label>
            <div class="form-fieldhelp-text">
              <div style="font-size: 14px; font-weight: normal">
                 Паспорт с&nbsp;таким же номером встречается у&nbsp;других посетителей
              </div>
            </div>
        </span>
        <a v-if="passportIsDuplicate()" :href="`?search=${identification.number}`">
          <p>{{ identification ? identification.number || '-' : '-' }}</p>
        </a>
          <p v-else >{{ identification ? identification.number || '-' : '-' }}</p>
        </div>
        <div class="col-md-3 col-sm-3 col-xs-3 mobile-width-75">
          <span class="name-label">Дата выдачи</span>
          <p>{{ identification ? identification.date_of || '-' : '-' }}</p>
        </div>
        <div class="col-md-3 col-sm-3 col-xs-3">
          <span class="name-label">Дата окончания</span>
          <p>{{ identification ? identification.date_to || '-' : '-' }}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-9 col-xs-9">
          <span class="name-label">Кем выдан</span>
          <p>{{ identification ? identification.place || '-' : '-' }}</p>
        </div>
        <div class="col-md-3 col-xs-3">
          <span class="name-label">Код подразделения</span>
          <p>{{ identification ? identification.code || '-' : '-' }}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-xs-12">
          <span class="name-label">Адрес</span>
          <p>{{ passport.address || '-' }}</p>
        </div>
      </div>
      <visitor-documents-block :documents="documents" />
    </div>

    <passport-application-list
      v-if="visibleApplications"
      :visitor-key="visitorKey"
      :passport-id="passport.id"
      :statuses="statuses"
      @open-application="openApplication"
      @update-statuses="updateStatuses"
      @splice-application="spliceApplication"
    />
  </div>
</template>

<script>
import VisitorDocumentsBlock from './VisitorDocumentsBlock.vue'
import PassportApplicationList from '@/common/components/visitor/PassportApplicationList.vue'

export default {
  name: 'VisitorPassportItem',

  components: {
    PassportApplicationList,
    VisitorDocumentsBlock
  },

  props: {
    passport: {
      id: Number,
      address: String,
      birthday: String,
      documents: [Object, Array],
      identification: {
        name: String,
        number: String,
        date_of: String,
        date_to: String,
        place: String,
        code: String
      },
      nationality: {
        iso2: String,
        fullName: String
      },
      placebirth: String
    },
    passportKey: Number,
    visitorKey: Number,
    statuses: { type: Object },
    duplicates: null
  },

  data() {
    return {
      baseUrl: process.env.VUE_APP_API_BASE_URL,
      titleApplicationsButton: 'Показать список заявок',
      showApplications: false
    }
  },

  computed: {
    identification() {
      return this.passport.identification
    },

    documents() {
      return this.passport.documents
    },

    visibleApplications() {
      return this.showApplications
    }
  },

  methods: {
    async changeVisibleApplications() {
      this.titleApplicationsButton = 'Показать список заявок'
      if (!this.showApplications) {
        this.titleApplicationsButton = 'Скрыть список заявок'
      }
      this.showApplications = !this.showApplications
    },

    spaceDelete(number) {
      return number.replaceAll(' ', '');
    },

    openApplication(applicationKey) {
      this.$emit('open-application', applicationKey)
    },

    spliceApplication(deleteFrom, blockId, applicationId, index) {
      this.$emit('splice-application', deleteFrom, blockId, applicationId, index)
    },

    updateStatuses(status) {
      this.$emit('update-statuses', status)
    },

    passportIsDuplicate() {
      return this.duplicates ? this.duplicates[this.identification.number] : null
    }
  }
}
</script>
